<template>
  <section>
    <div v-if="loading">
      <!-- END: Filter -->
      <div class="intro-y flex mb-4 flex-col-reverse sm:flex-row items-center">
        <div class="w-full sm:w-auto relative mr-auto mt-3 sm:mt-0">
          <app-icon
            v-bind:name="'search'"
            v-bind:classname="'w-4 h-4 absolute my-auto inset-y-0 ml-3 left-0 z-10 text-gray-700'"
          ></app-icon>
          <input
            type="text"
            class="input w-full sm:w-64 box px-10 text-gray-700"
            placeholder="Buscar por nombre"
            v-model="filter.name"
          />
          <div
            class="inbox-filter dropdown absolute inset-y-0 mr-3 right-0 flex items-center"
          >
            <app-icon
              v-bind:name="'chevron-down'"
              v-bind:classname="'dropdown-toggle w-4 h-4 cursor-pointer text-gray-700'"
            ></app-icon>
            <div
              class="inbox-filter__dropdown-box dropdown-box mt-10 absolute top-0 left-0 z-20"
            >
              <div class="dropdown-box__content box p-5">
                <div class="grid grid-cols-12 gap-4 row-gap-3">
                  <div class="col-span-6">
                    <div class="text-xs">Cuenta</div>
                    <select
                      class="input w-full border mt-2 flex-1"
                      v-model="filter.account"
                      required
                    >
                      <option disabled selected>Seleccione la cuenta</option>
                      <option
                        v-for="account in accounts"
                        v-bind:key="account.id"
                        v-bind:value="account.id"
                      >
                        {{ account.name }} - {{ account.country.prefix }}
                      </option>
                      <option value="">Todos</option>
                    </select>
                  </div>
                  <div class="col-span-6">
                    <div class="text-xs">Estado</div>
                    <select
                      class="input w-full border mt-2 flex-1"
                      v-model="filter.status"
                      required
                    >
                      <option disabled>Seleccione el estado</option>
                      <option value="0">Inactivo</option>
                      <option value="1">Activo</option>
                      <option value="">Todos</option>
                    </select>
                  </div>
                  <div class="col-span-6">
                    <div class="text-xs">Horas</div>
                    <select
                      class="input w-full border mt-2 flex-1"
                      v-model="filter.hours"
                      required
                    >
                      <option disabled>Seleccione una opción</option>
                      <option value="0">Sin horas</option>
                      <option value="1">1 Hora</option>
                      <option value="2">+1 Hora</option>
                      <option value="">Todos</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="w-full sm:w-auto flex">
          <a
            data-target="#project"
            data-toggle="modal"
            class="button text-white bg-theme-1 shadow-md mr-2"
            >Crear Proyecto</a
          >
        </div>
      </div>
      <!-- END: Filter -->

      <!-- List -->
      <h1 class="mb-2 text-lg font-bold">
        Proyectos ({{ filteredProjects.length }})
      </h1>
      <div
        class="intro-y col-span-6 sm:col-span-4 md:col-span-3 xxl:col-span-2"
        v-bind:key="project.id"
        v-for="project in filteredProjects"
      >
        <div
          class="bg-white mb-1 flex justify-between rounded-md py-3 px-5 sm:px-10 relative zoom-in"
        >
          <div class="w-1/3 block font-medium ext-center truncate">
            {{ project.name }}({{ project.hours }})
          </div>
          <div class="text-gray-600 text-xs text-center">
            {{ project.account.name }} - {{ project.account.country.prefix }}
          </div>
          <div class="file__icon__file-name">
            {{ project.status === 0 ? 'Inactivo' : 'Activo' }}
          </div>
          <div class="absolute top-0 right-0 mr-2 mt-2 dropdown ml-auto">
            <a class="dropdown-toggle w-5 h-5 block" href="javascript:;">
              <app-icon
                v-bind:name="'more-vertical'"
                v-bind:classname="'w-5 h-5 text-gray-500'"
              ></app-icon>
            </a>
            <div class="dropdown-box mt-5 absolute w-40 top-0 right-0 z-10">
              <div class="dropdown-box__content box p-2">
                <router-link
                  :to="'/admin/traffic/project/' + project.id"
                  class="flex items-center block p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md"
                >
                  <app-icon
                    v-bind:name="'edit'"
                    v-bind:classname="'w-4 h-4 mr-2'"
                  ></app-icon>
                  Editar
                </router-link>
                <a
                  v-on:click="removeProject(project)"
                  class="flex items-center block p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md"
                >
                  <app-icon
                    v-bind:name="'trash'"
                    v-bind:classname="'w-4 h-4 mr-2'"
                  ></app-icon>
                  Eliminar
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- END: List -->
    </div>

    <app-loading v-else />

    <!-- Modal -->
    <div class="modal" id="project">
      <div class="modal__content modal__content--sm">
        <div
          class="flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
        >
          <h2 class="font-medium text-base mr-auto">Crear Proyecto</h2>
        </div>
        <form @submit.prevent="createProject">
          <div class="p-5 grid grid-cols-12 gap-4 row-gap-3">
            <div class="col-span-12 sm:col-span-12">
              <label>Nombre</label>
              <input
                type="text"
                class="input w-full border mt-2 flex-1"
                v-model="project.name"
                required
              />
            </div>
            <div class="col-span-12 sm:col-span-12">
              <label>Cuenta</label>
              <select
                class="input w-full border mt-2 flex-1"
                v-model="project.account_id"
                required
              >
                <option disabled>Seleccione la cuenta</option>
                <option
                  v-for="account in accounts"
                  v-bind:key="account.id"
                  v-bind:value="account.id"
                >
                  {{ account.name }} - {{ account.country.prefix }}
                </option>
              </select>
            </div>
            <div class="col-span-12 sm:col-span-12">
              <label>Usuario</label>
              <select
                class="input w-full border mt-2 flex-1"
                v-model="project.user_id"
                required
              >
                <option disabled>Seleccione el usuario</option>
                <option
                  v-bind:key="user.id"
                  v-for="user in users"
                  v-if="user.roles[0].id >= 3"
                  v-bind:value="user.id"
                >
                  {{ user.name }}
                </option>
              </select>
            </div>
            <div class="col-span-12 sm:col-span-12">
              <label>Horas (Digital)</label>
              <input
                type="number"
                class="input w-full border mt-2 flex-1"
                v-model="project.hours"
                required
              />
            </div>
          </div>
          <div class="px-5 py-3 text-right border-t border-gray-200">
            <button
              type="button"
              data-dismiss="modal"
              class="button w-20 border text-gray-700 mr-1"
            >
              Cancelar
            </button>
            <button
              type="submit"
              class="button w-20 bg-theme-1 text-white"
              id="create"
            >
              Crear
            </button>
          </div>
        </form>
      </div>
    </div>
    <!-- Modal End -->
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Icon from '@/components/admin/partials/Icon'
import Loading from '@/components/admin/partials/LoadingWhite'

export default {
  name: 'AdminListProject',
  data() {
    return {
      loading: false,
      project: {
        user_id: '',
        name: '',
        account_id: '',
        entity: 'project',
        hours: 0,
      },
      filter: {
        name: '',
        account: '',
        status: '',
        hours: '',
      },
    }
  },
  computed: {
    ...mapGetters({
      projects: 'getProjects',
      users: 'getUsers',
      accounts: 'getAccounts',
    }),
    filteredProjects: function () {
      return this.projects.filter((item) => {
        let name = this.filter.name ? item.name.match(this.filter.name) : true
        let account_id = this.filter.account
          ? item.account_id === this.filter.account
          : true
        let status = this.filter.status
          ? item.status === parseInt(this.filter.status)
          : true
        let hours_filter = parseInt(this.filter.hours)
        console.log(hours_filter)
        let validate_hours =
          hours_filter > 1
            ? item.hours > hours_filter
            : item.hours === hours_filter
        let hours = this.filter.hours ? validate_hours : true

        return name && account_id && status && hours
      })
    },
  },
  beforeMount() {
    //SEND ENTITY AND MUTATION
    this.getAll('project').then(() => {
      this.loading = true
    }),
      this.getList('user').then(() => {
        this.loading = true
      }),
      this.getList('account').then(() => {
        this.loading = true
      })
  },
  methods: {
    createProject() {
      var vm = this
      vm.loading = false
      window.$('#create').button('loading')
      vm.store(vm.project)
        .then((item) => {
          window.$('#project').modal('hide')
          vm.project = {
            user_id: '',
            name: '',
            account_id: '',
            entity: 'project',
          }
          vm.loading = true
          window.$('#create').button('reset')
          vm.$router.replace(
            vm.$route.query.redirect || '/admin/traffic/projects'
          )
        })
        .catch((error) => {
          window.$('#create').button('reset')
          vm.project = {
            user_id: '',
            name: '',
            account_id: '',
            entity: 'project',
          }
          vm.loading = true
        })
    },
    removeProject: function (value) {
      var vm = this
      vm.form = {
        id: value.id,
        entity: 'project',
      }
      vm.remove(vm.form)
        .then((item) => {
          vm.loading = true
          vm.$router.replace(
            vm.$route.query.redirect || '/admin/traffic/projects'
          )
        })
        .catch((message) => {
          vm.loading = true
        })
    },
    ...mapActions(['getAll', 'getList', 'remove', 'store']),
  },
  components: {
    appIcon: Icon,
    appLoading: Loading,
  },
}
</script>



// WEBPACK FOOTER //
// ListProject.vue?d27e2d52